import { LogOut } from "lucide-react";
import { LOGOUT_URL } from "./api";
import { useIdentity } from "./hooks";

/**
 * Who you are, and the way out. Renders nothing when signed out — the sign-in
 * call to action belongs in the page body, not duplicated in the chrome.
 *
 * Sign-out is a real form POST rather than a fetch. POST because signing out
 * changes state and should not be reachable by a link a browser might prefetch;
 * a form because the response is a 303 the browser should follow, which lands
 * on a freshly-booted app with no session rather than a cached one that still
 * believes it is signed in.
 *
 * `useIdentity` is shared with `AuthGate` through the Query cache, so this
 * costs no extra request.
 */
export function IdentityChip() {
  const { data } = useIdentity();

  if (!data) return null;

  return (
    <div className="flex items-center gap-3">
      <span className="hidden text-ink-400 sm:inline" title={data.email}>
        {data.email}
      </span>
      <form method="post" action={LOGOUT_URL}>
        <button
          type="submit"
          className="flex items-center gap-1.5 text-ink-400 transition-colors hover:text-ink-50"
        >
          <LogOut size={12} />
          Sign out
        </button>
      </form>
    </div>
  );
}
